/* eslint-disable camelcase */
import React, { useContext, useEffect } from 'react'
import { PagesContext } from '../../context/FormPagesContext'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import styled from 'styled-components'
import axios from 'axios'

import Sidebar from './Sidebar'
import PersonalInfo from './PersonalInfo'
import EducationalBackground from './EducationalBackground'
import JobExperience from './JobExperience'
import Skill from './Skill'
import CharacterReference from './CharacterReference'
import PreviewCV from './PreviewCV'

import AuthLayouts from '../../layouts/AuthLayouts'

import ReactGA4 from '../../lib/ReactGA4'

import { baseUrl } from '../../constants/constant'

import { getFromSessionStorage } from '../../utils/util'

const MainOnboard = () => {
  const { page, setSoftSkillOption } = useContext(PagesContext)

  useEffect(() => {
    const reactGA4 = new ReactGA4()
    reactGA4.sendPageView('Manage CV')
  }, [])

  useEffect(() => {
    axios
      .get(`${baseUrl}/skills`, {
        headers: {
          Authorization: 'Bearer ' + getFromSessionStorage('token'),
        },
      })
      .then((res) => {
        res.data.data.softSkills.map((skill) => {
          if (skill !== '') {
            setSoftSkillOption((prevState) => [
              ...prevState,
              { value: skill, label: skill },
            ])
          }

          return 'skill'
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  const steps = [
    { value: 0.16, text: 'Personal Information' },
    { value: 0.32, text: 'Educational Background' },
    { value: 0.48, text: 'Job Experience' },
    { value: 0.64, text: 'Skills' },
    { value: 0.8, text: 'Character Reference' },
    { value: 1, text: 'Preview CV' },
  ]

  return (
    <DndProvider backend={HTML5Backend}>
      <AuthLayouts width="750px">
        <StyledMain>
          <Sidebar steps={steps} />
          {page === 0.16 && <PersonalInfo />}
          {page === 0.32 && <EducationalBackground />}
          {page === 0.48 && <JobExperience />}
          {page === 0.64 && <Skill />}
          {page === 0.8 && <CharacterReference />}
          {page === 1 && <PreviewCV />}
        </StyledMain>
      </AuthLayouts>
    </DndProvider>
  )
}

export default MainOnboard

export const StyledMain = styled.section`
  width: 100%;
  display: flex;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`
